/**
 * product-recond-panel.js — Panneau « Reconditionnement » (snippets/product-recond-panel.liquid).
 *
 * Ouverture, fermeture et verrou de scroll : assets/product-drawer.js. Ce fichier ne décide que
 * de la visibilité de « Voir l'inspection complète » : le certificat n'est dans la page que si
 * la section inspection est rendue.
 */
(function () {
  'use strict';

  if (window.__recondPanelBound) return;
  window.__recondPanelBound = true;

  document.addEventListener('mb-drawer:open', function (e) {
    var dialog = e.target;
    if (!dialog.classList || !dialog.classList.contains('product-recond')) return;
    var button = dialog.querySelector('[data-recond-certificate]');
    if (button) button.hidden = !document.querySelector('[data-certificate-doc]');
  });
})();
